import { UrlObject } from 'url';

export enum NextRouterType {
  APP = 'app',
  PAGE = 'page',
}

// export type NextAppRouterPushFunction = (href: string, options?: { forceOptimisticNavigation?: boolean }) => void; // Next 14 migration
export type NextAppRouterPushFunction = (href: string, options?: { scroll?: boolean }) => void;
export type NextPageRouterPushFunction = (
  url: string,
  as?: UrlObject | string | undefined,
  options?: { shallow?: boolean }
) => Promise<boolean>;

export type NextRouterPushFunction = NextAppRouterPushFunction | NextPageRouterPushFunction;

export interface NextRouterOptions {
  routerType: NextRouterType;
  routerPushFn: NextRouterPushFunction;
}

export const routerPush = (url: string, routerType: NextRouterType, routerPushFn: NextRouterPushFunction) => {
  if (routerType === NextRouterType.PAGE) {
    routerPushFn(url, undefined, { shallow: true });
  } else {
    routerPushFn(url);
  }
};
